import styled from "@emotion/styled";

import { BillingOverviewCards } from "./cards/BillingOverviewCards";
import { InvoicesSection } from "./invoices/InvoicesSection";
import { PlansSection } from "./plans/PlansSection";
import { useAccount } from "./useAccount";

export const AccountPage = () => {
  const account = useAccount();
  const hasAccount = account.data?.customer != null;

  return (
    <Container>
      <BillingOverviewCards />

      <PlansSection />

      {hasAccount && <InvoicesSection />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-flow: column;

  background: ${({ theme }) => theme.surfaceVariant};

  padding: 20px 0;
  gap: 20px;
`;
